module.exports = __webpack_public_path__ + "static/media/raffles_1.8250e24c.jpg";